import { render } from "./MagentoWhy.vue?vue&type=template&id=5a983783"
import script from "./MagentoWhy.vue?vue&type=script&lang=js"
export * from "./MagentoWhy.vue?vue&type=script&lang=js"

import "./MagentoWhy.vue?vue&type=style&index=0&id=5a983783&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__